import { type Palette } from '@mui/material';
import { grey } from '@mui/material/colors';

export const themeOverrides = {
  backgroundPrimary: '#ffffff',
  mainTextPrimary: grey[100],
  mainTextSecondary: grey[900],
  supportingTextPrimary: grey[500],
  supportingTextSecondary: grey[600],
  typography: (palette: Palette) => ({
    h1: {
      color: palette.grey[100],
    },
    h2: {
      color: palette.grey[100],
    },
    h3: {
      color: palette.grey[100],
    },
    h4: {
      color: palette.grey[100],
    },
    h5: {
      color: palette.grey[100],
    },
    h6: {
      color: palette.grey[100],
    },
  }),
};
